import { Stack, Typography, IconButton, Tooltip, Box } from "@mui/material";
import { Pencil, Trash2 } from "lucide-react";
import CardWithHeader from "../../components/cards/CardWithHeader";
import { TextInput, ButtonSelectionInput } from "../../components/inputs";
import { colors, fontSizes } from "../../theme";
import { OocyteUpload, OocyteCondition } from "./types";

const OocyteCard: React.FC<{
    oocyteUpload: OocyteUpload;
    index: number;
    translations: any;
    handleUploadReplace: (index: number) => void;
    handleUploadDelete: (index: number) => void;
    setOocyteUploads: React.Dispatch<React.SetStateAction<OocyteUpload[]>>;
    oocyteUploads: OocyteUpload[];
    conditionOptions: { value: string; label: string }[];
  }> = ({
    oocyteUpload,
    index,
    translations,
    handleUploadReplace,
    handleUploadDelete,
    setOocyteUploads,
    oocyteUploads,
    conditionOptions,
  }) => {
    return (
      <CardWithHeader key={index} headerColor={"white"} title={``}>
        <Stack spacing={2}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            gap={2}
          >
            <Typography fontSize={fontSizes.sm} color={colors.stone[900]}>
              {`${translations.form.labels.oocyte} ${index + 1}`}
            </Typography>
  
            <Stack direction="row" gap={1}>
              <Tooltip title={translations.form.upload.replace}>
                <IconButton onClick={() => handleUploadReplace(index)}>
                  <Pencil width={24} />
                </IconButton>
              </Tooltip>
              <Tooltip title={translations.form.upload.delete}>
                <IconButton onClick={() => handleUploadDelete(index)}>
                  <Trash2 width={24} />
                </IconButton>
              </Tooltip>
            </Stack>
          </Stack>
  
          <Stack direction="row" gap={2} justifyContent="space-between">
            <Box maxWidth={300} position="relative" width="50%">
              <img
                width="100%"
                src={oocyteUpload.fileUrl}
                alt={`${translations.form.labels.oocyte} ${index + 1}`}
              />
            </Box>
            <Stack gap={1}>
              <TextInput
                type="number"
                adornment={translations.form.labels.hours}
                label={translations.form.labels.timePostHarvesting}
                value={oocyteUpload.hph}
                onFocus={(ev) => ev.target.select()}
                onChange={(value) => {
                  setOocyteUploads((prev) =>
                    prev.map((item, i) =>
                      i === index ? { ...item, hph: value as number | null } : item
                    )
                  );
                }}
              />
              <ButtonSelectionInput
                value={oocyteUpload.condition ? [oocyteUpload.condition] : []}
                options={conditionOptions}
                onChange={(value) => {
                  if (value.length > 0) {
                    setOocyteUploads((prev) =>
                      prev.map((item, i) =>
                        i === index ? { ...item, condition: value[0] as OocyteCondition } : item
                      )
                    );
                  }
                }}
                label={translations.form.labels.condition}
              />
            </Stack>
          </Stack>
        </Stack>
      </CardWithHeader>
    );
  };

  export default OocyteCard;